import React from 'react';
import { Typography } from 'src/ui/common/atoms/typography';
import { StyledRowItem } from './styles';

export const RowWrapper: React.FC<{ label: string }> = ({ label, children }) => (
    <StyledRowItem alignItems="center" justifyContent="space-between">
        <Typography size="sm">{label}</Typography>
        {children}
    </StyledRowItem>
);
